import { inject, Injectable } from "@angular/core";
import { SecurityService } from "common";
import { RoleService } from "./role.service";
import { Role } from "../interfaces/role.interface";
import { ProfileService } from "./profile.service";

@Injectable({
  providedIn: 'root',
})
export class HeaderNavigationService {
  private securityService = inject(SecurityService);
  private roleService = inject(RoleService);
  private profileService = inject(ProfileService);

  getNavItems() {
    const loggedIn = this.securityService.isLoggedIn();

    const publicItems = {};

    const adminItems = {
      'SIDO/PA/MSP Registrations': [{ route: 'registrations', }],
      'Sender IDs': [
        { route: 'sender-ids', displayName: 'All' },
        { route: 'sender-ids/pending', displayName: 'Pending' },
      ],
      'Manage Block List': [
        { route: 'sender-ids/block-list', },
      ]
    };

    const sidoAndPaItems = {
      'Manage Account': [
        { route: `registrations/${this.profileService.shortAccountId}`, }
      ],
      'My Sender IDs': [
        { route: 'sender-ids', },
      ],
    };

    const paItems = {
      'Sender ID OPA Authorised List': [
        { route: 'opas/authorised-sender-ids', },

      ],
      'API/Download Section': [
        { route: 'opas/download', },
      ],
    }

    if (loggedIn) {
      switch (this.roleService.role) {
        case Role.Admin:
          return adminItems;
        case Role.PaOrMsp:
          return { ...sidoAndPaItems, ...paItems };
        case Role.Sido:
          return sidoAndPaItems;
        default:
          return publicItems;
      }
    } else {
      return publicItems;
    }
  }
}
